import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { ViewMode, DrawPolygonMode, DrawPointMode, DrawLineStringMode, ModifyMode } from '@nebula.gl/edit-modes'
import { default as turfPolygon } from '@turf/area'
import { default as turfLine } from '@turf/length'
import { lineString } from '@turf/helpers'
import { polygon } from '@turf/helpers'
import AWS from 'aws-sdk'

import Grow from '@material-ui/core/Grow'
import Tooltip from '@material-ui/core/Tooltip'
import Divider from '@material-ui/core/Divider'

import rulerIcon from '../../../assets/ruler.png'
import areaIcon from '../../../assets/shape.png'
import searchIcon from '../../../assets/search2.png'
import coordinatesIcon from '../../../assets/coordinates.png'
import DownloadIcon from '../../../assets/cloud-download.png'
import RedMarker from '../../../assets/red_marker.png'

import Ruler from './ruler/Ruler'
import Area from './area/Area'
import Search from './search/Search'
import Coordinates from './coordinates/Coordinates'
import Download from './download/Download'

import RpcApiClient from 'datasources/RpcApiClient'

import './toolBar.css'

function ToolBar(props) {
  const authData = useSelector((state) => state.auth.authData)

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
  })

  const myBucket = new AWS.S3({
    params: { Bucket: process.env.REACT_APP_S3_BUCKET },
    region: process.env.REACT_APP_REGION,
  })

  const [toggle, setToggle] = useState(false)
  const [lbl, setLbl] = useState(0)
  const [coordinateslbl, setCoordinateslbl] = useState({ lat: '', lon: '' })
  const [showClick, setShowClick] = useState('flex')
  const [showManual, setShowManual] = useState('none')
  const [btn, setBtn] = useState([
    { tooltip: 'Ruler Tool', icon: rulerIcon, view: false },
    { tooltip: 'Area Tool', icon: areaIcon, view: false },
    { tooltip: 'Search Tool', icon: searchIcon, view: false },
    { tooltip: 'Search by Coordinates Tool', icon: coordinatesIcon, view: false },
    { tooltip: 'Download Request', icon: DownloadIcon, view: false },
  ])
  const [municipality, setMunicipality] = useState([])
  const [plants, setPlants] = useState([])
  const [substations, setSubstations] = useState([])

  const [progress, setProgress] = useState(0)
  const [tableToggle, setTableToggle] = useState(true)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState({ flag: false, message: '' })

  useEffect(() => {
    setMunicipality(props.municipality)
  }, [props.municipality])

  useEffect(() => {
    setPlants(props.plants)
  }, [props.plants])

  useEffect(() => {
    setSubstations(props.substations)
  }, [props.substations])

  useEffect(() => {
    //RULER
    if (btn[0].view && props.distance.length >= 2) {
      setLbl(turfLine(lineString(props.distance), { units: 'kilometers' }))
    }
    //AREA
    if (btn[1].view) {
      try {
        props.distance[0].toString() === props.distance.slice(-1).toString() && props.distance[0].length > 3
          ? setLbl(turfPolygon(polygon([props.distance[0]])))
          : null
      } catch (e) {
        null
      }
    }
    //COORDINATES
    if (btn[3].view) {
      try {
        setCoordinateslbl({ lat: props.distance[1].toFixed(3) + ',', lon: props.distance[0].toFixed(3) })
      } catch (e) {
        null
      }
    }
    //DOWNLOAD
    if (btn[4].view) {
      try {
        props.distance[0].toString() === props.distance.slice(-1).toString() && props.distance[0].length > 3
          ? setLbl((turfPolygon(polygon([props.distance[0]])) / 1) * Math.pow(10, -6))
          : null
      } catch (e) {
        null
      }
    }
  }, [props.distance])

  useEffect(() => {
    if (props.current === 'raster') {
      changeMenu('close')
      props.setCrossPointer(false)
      props.setMode(() => ViewMode)
    }
  }, [props.current])

  const del = () => {
    props.setDistance([])
    setLbl(0)
    setCoordinateslbl({ lat: '', lon: '' })
    props.setFeatures({
      type: 'FeatureCollection',
      features: [],
    })
  }

  const changeMenu = (key) => {
    const buttons = btn
    buttons.map((obj) => {
      {
        obj.tooltip === key ? (obj.view = true) : (obj.view = false)
      }
    })
    setBtn(buttons)
  }

  const setPointer = (key, bool) => {
    props.setCurrent('tools')
    if (key === 'Ruler Tool') {
      del()

      props.setCrossPointer(bool)
      bool ? props.setMode(() => DrawLineStringMode) : props.setMode(() => ViewMode)
      props.setStyle({
        lineColor: [255, 99, 99],
        fillColor: [255, 99, 99, 125],
        tentativeLineColor: [255, 206, 206],
        tentativeFillColor: [255, 99, 99, 80],
        pointType: 'circle',
        url: null,
      })
    }
    if (key === 'Area Tool') {
      del()

      props.setCrossPointer(bool)
      bool ? props.setMode(() => DrawPolygonMode) : props.setMode(() => ViewMode)
      props.setStyle({
        lineColor: [247, 197, 45],
        fillColor: [247, 197, 45, 125],
        tentativeLineColor: [250, 225, 147],
        tentativeFillColor: [247, 197, 45, 80],
        pointType: 'circle',
        url: null,
      })
    }
    if (key === 'Search Tool') {
      props.setCrossPointer(false)
      del()
    }
    if (key === 'Search by Coordinates Tool') {
      setShowClick('flex')
      setShowManual('none')
      del()

      props.setCrossPointer(bool)
      bool ? props.setMode(() => DrawPointMode) : props.setMode(() => ViewMode)
      props.setStyle({
        lineColor: [40, 40, 40],
        fillColor: [120, 120, 120, 125],
        tentativeLineColor: [236, 236, 236],
        tentativeFillColor: [255, 255, 255, 80],
        pointType: 'icon',
        url: RedMarker,
      })
    }
    if (key === 'Download Request') {
      del()
      props.setCrossPointer(false)
      props.setMode(() => ViewMode)
      props.setStyle({
        lineColor: [192, 0, 227],
        fillColor: [192, 0, 227, 125],
        tentativeLineColor: [231, 130, 250],
        tentativeFillColor: [192, 0, 227, 80],
        pointType: 'circle',
        url: null,
      })
    }
  }

  const setDownload = (bool) => {
    props.setCrossPointer(bool)
    bool ? props.setMode(() => DrawPolygonMode) : props.setMode(() => ViewMode)
    del()
  }

  const viewState = (data) => {
    props.setInitialViewState(data)
  }

  const coordinates = (mode) => {
    if (mode === 'click') {
      props.setCrossPointer(true)
      props.setMode(() => DrawPointMode)
    }
    if (mode === 'txt') {
      props.setCrossPointer(false)
      props.setMode(() => ViewMode)
    }
  }

  const manualPoint = (data) => {
    props.setDistance(data)
    props.setFeatures({
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'Point',
            coordinates: data,
          },
        },
      ],
    })
  }

  useEffect(() => {
    if (progress === 100) {
      setSuccess(true)
      setTableToggle(false)
    }
  }, [progress])

  const uploadFile = (list) => {
    // console.log(authData.email)
    var f = new Date()

    const clientData = {
      map: props.map,
      client_email: authData.email, //laura@tycho.solutions
      infrastructure: {
        powerplants: list.plants,
        tranlines: list.lines,
        substations: list.substations,
      },
      protected_area: list.areas,
      flor_fauna: list.fauna,
      social: list.social,
      land_ownership: list.land,
      archeology: list.landmarks,
      geology: list.hydro,
      municipality: false,
      imagen: `https://mail-test-img.s3.amazonaws.com/engie/engie_${
        f.getHours() +
        '' +
        f.getMinutes() +
        '' +
        f.getSeconds() +
        '_' +
        f.getDate() +
        '_' +
        f.getMonth() +
        '_' +
        f.getFullYear()
      }_mexico-engie.jpg`,
      coordinates: props.distance.map((obj) => {
        return obj.toString().replace(',', ' ')
      }),
    }

    const tychoData = {
      map: props.map,
      client_email: authData.email,
      infrastructure: {
        powerplants: list.plants,
        tranlines: list.lines,
        substations: list.substations,
      },
      protected_area: list.areas,
      flor_fauna: list.fauna,
      social: list.social,
      land_ownership: list.land,
      archeology: list.landmarks,
      geology: list.hydro,
      municipality: false,
      imagen: `https://mail-test-img.s3.amazonaws.com/engie/engie_${
        f.getHours() +
        '' +
        f.getMinutes() +
        '' +
        f.getSeconds() +
        '_' +
        f.getDate() +
        '_' +
        f.getMonth() +
        '_' +
        f.getFullYear()
      }_mexico-engie.jpg`,
      coordinates:
        '[' +
        props.distance
          .map((obj) => {
            return obj.toString().replace(',', ' ')
          })
          .toString() +
        ']',
    }

    props
      .handleDownload()
      .then((file) => {
        const params = {
          ACL: 'public-read',
          Body: file,
          Bucket: process.env.REACT_APP_S3_BUCKET,
          Key: `engie/engie_${
            f.getHours() +
            '' +
            f.getMinutes() +
            '' +
            f.getSeconds() +
            '_' +
            f.getDate() +
            '_' +
            f.getMonth() +
            '_' +
            f.getFullYear()
          }_mexico-engie.jpg`,
        }

        RpcApiClient.downloadMail(authData.jwtToken, clientData, tychoData).then((val) => {
          // if (val) {
          myBucket
            .putObject(params)
            .on('httpUploadProgress', (evt) => {
              setProgress(Math.round((evt.loaded / evt.total) * 100))
            })
            .send((err) => {
              if (err) {
                setSuccess(false)
                setTableToggle(false)
                setError({ flag: true, message: `S3: ${err.message}` })
              }
            })
          // } else {
          // setSuccess(false)
          // setTableToggle(false)
          // setError({ flag: true, message: 'Request Failed' })
          // }
        })
      })
      .catch((err) => {
        setSuccess(false)
        setTableToggle(false)
        setError({ flag: true, message: 'Request Failed' })
        // setError({ flag: true, message: err.message })
        console.log(err)
      })
  }

  return (
    <div className="toolbar-container">
      {btn.map((data) =>
        data.tooltip === 'Download Request' &&
        props.sidebarData.find((obj) => obj.title === data.tooltip) === undefined ? null : (
          <div style={{ display: 'flex' }}>
            <Tooltip title={data.tooltip} placement="bottom" arrow>
              {data.view ? (
                <button
                  type="button"
                  className="toolbar-btn"
                  style={{ backgroundColor: '#d4d9df' }}
                  onClick={() => {
                    changeMenu(data.key)
                    setPointer(data.tooltip, false)
                  }}
                >
                  <img src={data.icon} className="icon-align-inf" />
                </button>
              ) : (
                <button
                  type="button"
                  className="toolbar-btn"
                  onClick={() => {
                    changeMenu(data.tooltip)
                    setPointer(data.tooltip, true)
                  }}
                >
                  <img src={data.icon} className="icon-align-inf" />
                </button>
              )}
            </Tooltip>
            <Divider orientation="vertical" flexItem />
          </div>
        ),
      )}
      <Ruler menu={btn} lbl={lbl} delete={del} setPointer={setPointer} />
      <Area menu={btn} lbl={lbl} delete={del} setPointer={setPointer} />
      <Search menu={btn} plants={plants} municipality={municipality} substations={substations} viewState={viewState} />
      <Coordinates
        menu={btn}
        coordinates={coordinates}
        coordinateslbl={coordinateslbl}
        setCoordinateslbl={setCoordinateslbl}
        delete={del}
        viewState={viewState}
        manualPoint={manualPoint}
        showClick={showClick}
        setShowClick={setShowClick}
        showManual={showManual}
        setShowManual={setShowManual}
      />
      <Download
        menu={btn}
        lbl={lbl}
        delete={del}
        setPointer={setPointer}
        uploadFile={uploadFile}
        progress={progress}
        setProgress={setProgress}
        success={success}
        setSuccess={setSuccess}
        tableToggle={tableToggle}
        setTableToggle={setTableToggle}
        error={error}
        setError={setError}
        setDownload={setDownload}
      />
    </div>
  )
}

export default ToolBar
